import React from "react";
import { browser } from "@/utils/utils";
import styles from "./index.module.less";

const WXappTips = ({ clickCallBack }) => {
  return (
    <div className={styles["tips-box"]} onClick={clickCallBack}>
      {browser("ios") ? (
        <img src={require("@/images/shadeTip/ios.png")} alt="ios.png" />
      ) : (
        <img src={require("@/images/shadeTip/android.png")} alt="android.png" />
      )}
    </div>
  );
};
export default WXappTips;
